import ApplicationSerializer from "./application";

export default class PlatformArgumentSerializer extends ApplicationSerializer {
  normalize(modelClass, resourceHash, prop) {
    if (resourceHash.response) {
      let [platformArguments] = Object.values(resourceHash.response.argumentslist.platforms);
      resourceHash = { ...platformArguments, id: resourceHash.id };
    }

    resourceHash.externalBandwidthOptions = resourceHash.bandwidth;
    resourceHash.internalBandwidthOptions = resourceHash.internalbandwidth;
    resourceHash.cpuCores = resourceHash.cpucores;
    resourceHash.dataCenters = resourceHash.datacenter;
    resourceHash.diskSizes = resourceHash.disksize;
    resourceHash.memorySizes = resourceHash.memorysize;
    resourceHash.veeam = resourceHash.backup_veeam;
    resourceHash.idera = resourceHash.backup_idera;
    resourceHash.bacula = resourceHash.backup_bacula;

    return super.normalize(modelClass, resourceHash, prop);
  }
}
